/**
 * 通过mutations间接更新state的多个方法的对象
 */
import {
	SET_USER_NAME
  } from './mutation-types'

export default {
    setUserName({commit,state}, userName){
        commit(SET_USER_NAME,{userName})
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js